<template>
    <div>
        <nav id="main-nav" style="display: flex;" class="navbar navbar-expand-md navbar-dark fixed-top px-5">
            <div class="logo-container">
                <inertia-link href="/"><img alt="Familjekortet logga" src="/assets/frontend/logo.png" class="logo-img" /></inertia-link>
            </div>

            <div style="width: 33.333333%;">
                <input class="form-control bg-white search-input" v-model="query" type="search" style="width: 100%;margin: 0px;font-family: 'AvertaRegular';"  :placeholder="$t('search_discounts')+ '..'" v-on:keyup.enter="search"/>
            </div>

            <div v-if="currentUser" class="d-none d-md-block" style="margin-left: auto;">
                <inertia-link
                    v-if="['member'].includes(currentUser.type)"
                    href="/profil"
                    style="display: inline-block; text-align: center;">
                    <icon name="user"></icon>

                    <div class="mt-1">
                        Mina Sidor
                    </div>
                </inertia-link>

                <a
                    v-if="['client'].includes(currentUser.type)"
                    href="/kund"
                    style="display: inline-block; text-align: center;">
                    <icon name="user"></icon>

                    <div class="mt-1">
                        Mina Sidor Företag
                    </div>
                </a>

                <a
                    v-if="['superadmin', 'admin'].includes(currentUser.type)"
                    href="/admin"
                    style="display: inline-block; text-align: center;">
                    <icon name="user"></icon>

                    <div class="mt-1">
                        Backoffice
                    </div>
                </a>

                <inertia-link href="/favoriter" class="ms-3" style="display: inline-block; text-align: center;">
                    <icon name="heart"></icon>

                    <div class="mt-1">
                        Favoriter
                    </div>
                </inertia-link>
            </div>

            <div v-if="!currentUser" class="d-none d-md-block" style="margin-left: auto;">
                <a href="#" class="login-button" type="button" data-bs-toggle="modal" data-bs-target="#loginModal" style="display: inline-block; text-align: center;text-decoration: none;">
                    <icon name="user"></icon>

                    <div class="mt-1">
                        {{ $t('login') }}
                    </div>
                </a>
            </div>

            <!-- <div class="buttons-container">
                <div class="d-inline mr-4">
                    <template v-if="['member', 'client'].includes($page.props.currentUser?.type)">
                        <inertia-link
                            v-if="$page.props.currentUser.type === 'member'" class="login-button"
                            href="/profil">
                            <icon name="user"></icon>
                        </inertia-link>

                        <a v-if="$page.props.currentUser.type === 'client'" href="/kund">
                            <icon name="user"></icon>
                        </a>
                    </template>

                    <template v-if="['superadmin', 'admin'].includes($page.props.currentUser?.type)">
                        <a
                            class="login-button"
                            href="/admin">
                            <icon name="user"></icon>
                        </a>
                    </template>

                    <icon v-if="!$page.props.currentUser" name="user"></icon>


                    <inertia-link v-if="$page.props.currentUser" href="/mina-favoriter">
                        <icon name="heart" class="ml-2"></icon>
                    </inertia-link>
                </div>
                <button v-if="!$page.props.currentUser" class="btn btn-danger register-button" type="button" data-toggle="modal" data-backdrop="static" data-target="#registerModal"> {{ $t('register') }}</button>
            </div> -->

        </nav>
        <nav v-if="!isNative" class="navbar navbar-expand-md fixed-top" id="menu-nav">
            <div class="container-fluid">
                <ul class="navbar-nav mx-auto">
                    <li class="nav-item dropdown">
                        <a class="nav-link dropdown-toggle text-bold" href="#" id="navbarDropdownMenuLink" data-bs-toggle="dropdown" data-bs-target="#categoriesDropdown" aria-haspopup="true" aria-expanded="false">
                            Kategorier
                        </a>

                        <div class="collapse navbar-collapse" id="categoriesDropdown">
                            <ul class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
                                <li class="dropdown-submenu" v-for="category in categories.filter(c => c.parent_id === null)" :key="category.id" style="display: flex;">
                                    <inertia-link :href="`/${category.slug}`" class="dropdown-item" href="#">
                                        <icon houseColor="#e4f4fb" :height="40" :width="40" :name="category.slug" style="margin-right: 5px;"></icon>
                                        {{ category.name }}
                                    </inertia-link>
                                    <a class="dropdown-item dropdown-toggle" href="#" style="width: 10%;"></a>
                                    <ul class="dropdown-menu">
                                        <li v-for="subcategory in categories.filter(c => c.parent_id === category.id)" :key="subcategory.id">
                                        <inertia-link :href="`/${category.slug}/${subcategory.slug}`" class="dropdown-item" href="#">{{ subcategory.name }}</inertia-link></li>
                                    </ul>
                                </li>
                            </ul>
                        </div>
                    </li>

                    <li class="nav-item" v-bind:class="{ active: false }">
                        <inertia-link class="nav-link text-bold" href="/topplista">{{ $t('toplista') }}</inertia-link>
                    </li>

                    <li class="nav-item" v-bind:class="{ active: false }">
                        <inertia-link class="nav-link text-bold" href="/online">E-handel</inertia-link>
                    </li>

                    <li class="nav-item" v-bind:class="{ active: false }">
                        <inertia-link class="nav-link text-bold" :href="`/${$page.props.currentCity.slug}`">
                            <template v-if="currentUser">
                                {{ $page.props.currentCity.name }}
                            </template>

                            <template v-if="!currentUser">
                                Lokala hjältar
                            </template>
                        </inertia-link>
                    </li>

                    <!-- <li class="nav-item">
                       <router-link class="nav-link text-bold" :to="{ name: 'map'}">{{ $t('near_you') }} <icon name="location-solid"></icon></router-link>
                    </li> -->
                    <li class="nav-item" v-bind:class="{ active: false }">
                        <inertia-link class="nav-link text-bold" href="/kampanjer">{{ $t('all_discounts') }}</inertia-link>
                    </li>
                    <li class="nav-item" v-bind:class="{ active: false }">
                        <inertia-link class="nav-link text-bold" href="/alla-foretag">{{ $t('all_companies') }}</inertia-link>
                    </li>
                    <li class="nav-item" v-bind:class="{ active: false }">
                        <inertia-link class="nav-link text-bold" href="/vara-partners">{{ $t('our_partners') }}</inertia-link>
                    </li>
                    <!-- <li class="nav-item">
                        <a class="nav-link" @click="checkIfClient">{{ $t('for_companies') }}</a>
                    </li> -->
                    <li class="nav-item" v-bind:class="{ active: false }">
                        <inertia-link class="nav-link" href="/vanliga-fragor">{{ $t('faq') }}</inertia-link>
                    </li>
                    <li class="nav-item" v-bind:class="{ active: false }">
                        <inertia-link class="nav-link" href="/om-oss">{{ $t('about_familjekortet') }}</inertia-link>
                    </li>
                </ul>
            </div>
        </nav>

        <nav class="navbar fixed-bottom" id="bottom-nav" style="z-index: 2990;">
            <ul class="list-inline m-0">
                <li class="list-inline-item trigger-search-input" @click="linkBack">
                    <icon name="menu-back"></icon>
                    <span>Tillbaka</span>
                </li>
                <li class="list-inline-item trigger-search-input" @click="openCloseMobileSearch">
                   <icon name="search"></icon>
                    <span>{{ $t('search') }}</span>
                </li>
                <!-- <li class="list-inline-item" @click="showHideCities()">
                    <icon name="location"></icon>
                    <span v-if="selectedCity" >{{selectedCity.name}}</span>
                    <span v-if="!selectedCity">välj stad</span>
                </li> -->
                <li class="list-inline-item active trigger-menu" @click="openCloseMenu">
                    <icon name="menu-burger"></icon>
                    <span>{{ $t('menu') }}</span>
                </li>
                <li class="list-inline-item trigger-menu d-none" @click="openCloseMenu">
                    <icon name="close"></icon>
                    <span>{{ $t('menu') }}</span>
                </li>
                <li @click="scrollToTop" class="list-inline-item">
                    <inertia-link href="/topplista" class="no-underline">
                        <icon name="star"></icon>
                        <span>{{ $t('toplista') }}</span>
                    </inertia-link>
                </li>
                <li @click="scrollToTop" class="list-inline-item" v-if="!currentUser">
                    <span data-bs-toggle="modal" data-bs-target="#loginModal">
                        <icon name="user"></icon>
                        <span>{{ $t('login') }}</span>
                    </span>
                </li>
                <li @click="scrollToTop" class="list-inline-item" v-if="currentUser">
                    <inertia-link href="/favoriter">
                        <icon name="heart"></icon>
                        <span>Favoriter</span>
                    </inertia-link>
                </li>
            </ul>
        </nav>
        <div class="mobile-menu close" style="z-index: 2080;">
            <ul class="list-item list-unstyled pt-0" style="margin: 0;">
                <li class="active others-item bold" style="padding: 0;">
                    <span style="padding: 20px 22px; display: flex;" @click="categoriesExpanded = !categoriesExpanded">
                        <span>Kategorier</span>

                        <icon name="plus" class="ml-auto" v-if="!categoriesExpanded"></icon>
                        <icon name="close" class="ml-auto" v-else></icon>
                    </span>
                </li>
            </ul>

            <ul class="animate slide-in list-item list-unstyled pt-0" style="margin: 0;" v-if="categoriesExpanded">
                <li class="active others-item" style="padding: 0px;" v-for="category in categories.filter((c) => c.parent_id === null)" :key="category.id">
                    <div style="display: flex;">
                        <span @click="openCloseMenu">
                            <inertia-link :href="`/${category.slug}`" style="display: block; padding: 20px 22px;">
                                <icon house-color="#E4F4FB" :name="category.slug" width="38" height="38"></icon>

                                <span class="ml-1">{{ category.name }}</span>
                            </inertia-link>
                        </span>

                        <span @click="(subcategoriesExpanded === category.id) ? subcategoriesExpanded = null : subcategoriesExpanded = category.id" style="margin-left: auto;padding: 20px 22px;display: flex;align-items: center;">
                            <icon name="close" width="27" height="27" class="float-right" v-if="subcategoriesExpanded === category.id"></icon>
                            <icon name="plus" width="27" height="27" class="float-right" v-else></icon>
                        </span>
                    </div>

                    <ul v-if="subcategoriesExpanded === category.id" class="list-item list-unstyled pt-0" style="margin-left: 35px; margin-top: 20px;" :id="`collapseCategory-${category.slug}`">
                        <li v-for="(subcategory, index) in categories.filter((c) => c.parent_id === category.id)">
                            <span @click="openCloseMenu">
                                <inertia-link :href="`/${category.slug}/${subcategory.slug}`" style="padding: 10px 22px; display: block;">
                                    {{ subcategory.name }}
                                </inertia-link>
                            </span>
                        </li>
                    </ul>
                </li>
            </ul>

            <ul class="menu-list p-0" id="categories-mobile">
                <ul class="list-item list-unstyled pt-0">
                    <li class="active others-item bold">
                        <span @click="openCloseMenu">
                            <inertia-link href="/topplista" class="no-underline">
                                Topplistan
                            </inertia-link>
                        </span>
                     </li>

                     <li class="active others-item bold">
                        <span @click="openCloseMenu">
                            <inertia-link href="/online" class="no-underline">
                                E-Handel
                            </inertia-link>
                        </span>
                     </li>

                     <li class="active others-item bold">
                        <span @click="openCloseMenu">
                            <inertia-link :href="`/${$page.props.currentCity.slug}`" class="no-underline">
                                <template v-if="currentUser">
                                    {{ $page.props.currentCity.name }}
                                </template>

                                <template v-if="!currentUser">
                                    Lokala hjältar
                                </template>
                            </inertia-link>
                        </span>
                     </li>

                     <li class="active others-item bold">
                        <span @click="openCloseMenu">
                            <inertia-link href="/kampanjer" class="no-underline">
                                Alla rabatter
                            </inertia-link>
                        </span>
                     </li>

                     <li class="active others-item bold">
                        <span @click="openCloseMenu">
                            <inertia-link href="/alla-foretag" class="no-underline">
                                Alla företag
                            </inertia-link>
                        </span>
                     </li>

                     <li class="active others-item bold">
                        <span @click="openCloseMenu">
                            <inertia-link href="/vara-partners" class="no-underline">
                                Våra partners
                            </inertia-link>
                        </span>
                     </li>

                     <li class="active others-item regular">
                        <span @click="openCloseMenu">
                            <inertia-link href="/vanliga-fragor" class="no-underline">
                                Frågor & Svar
                            </inertia-link>
                        </span>
                     </li>

                     <li class="active others-item regular" v-if="currentUser && ['member'].includes(currentUser.type)">
                        <span @click="openCloseMenu">
                            <inertia-link href="/profil" class="no-underline">
                                Mina Sidor
                            </inertia-link>
                        </span>
                     </li>

                     <li class="active others-item regular" v-if="currentUser && ['client'].includes(currentUser.type)">
                        <span @click="openCloseMenu">
                            <a href="/kund" class="no-underline">
                                Mina Sidor Företag
                            </a>
                        </span>
                     </li>

                     <li class="active others-item regular" v-if="currentUser">
                        <span @click="openCloseMenu">
                            <inertia-link href="/favoriter" class="no-underline">
                                Favoriter
                            </inertia-link>
                        </span>
                     </li>

                     <li class="active others-item regular">
                        <span @click="openCloseMenu">
                            <inertia-link href="/om-oss" class="no-underline">
                                Om Familjekortet
                            </inertia-link>
                        </span>
                     </li>

                     <li class="active others-item regular">
                        <span @click="openCloseMenu">
                            <inertia-link href="/kontakta-oss" class="no-underline">
                                Kontakta oss
                            </inertia-link>
                        </span>
                     </li>
                </ul>
            </ul>
        </div>

        <div class="mobile-search fixed-bottom close" style="z-index: 9999999;">
            <div class="p-3 d-flex w-100 mobile-search-input-wrapper">
                <span @click="search"><icon name="search"></icon> </span>
                <input type="text" class="form-control" v-model="query" placeholder="Sök efter rabatter, erbjudanden, städer..."  v-on:keyup.enter="search">
                <span @click="openCloseMobileSearch"> <icon name="close"></icon> </span>
            </div>
        </div>

        <!-- REGISTER FORM MODAL -->
        <div class="modal fade bd-example-modal-lg" id="registerModal" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content register-form">
                    <div class="modal-header">
                        <button data-bs-toggle="modal" data-bs-target="#registerModal" type="button" class="btn-close" aria-label="Close"></button>
                    </div>
                    <register-component v-bind:cities="cities"></register-component>
                </div>
            </div>
        </div>
        <!-- END REGISTER FORM MODAL -->

        <!-- SUCCESSFUL REGISTRATION MODAL -->
        <div class="modal fade bd-example-modal-sm" id="successRegistrationModal" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-sm" role="document">
                <div class="modal-content register-form success-registration">
                   <span style="color: #E05054;text-transform: uppercase;font-family: 'AvertaBlack';font-size: 2.4rem;margin: 2rem 0rem 2rem 0rem;">Supertack!</span>
                   <span>Nu kan du komma åt alla våra härliga erbjudanden och vassa rabattkoder!</span>
                   <button @click="closeSuccessRegistrationModal" class="btn btn-danger">Sök rabatter</button>
                </div>
            </div>
        </div>
        <!-- SUCCESSFUL REGISTRATION MODAL -->

        <!-- SUCCESSFUL REGISTRATION MODAL -->

        <div class="modal fade bd-example-modal-sm" id="emailSent" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-sm" role="document">
                <div class="modal-content register-form success-registration">
                   <span style="color: #E05054;text-transform: uppercase;font-family: 'AvertaBlack';font-size: 2.4rem;margin: 2rem 0rem 2rem 0rem;line-height: 1;">E-post skickas!</span >
                   <span>Du har fått ett meddelande till din e-postadress med instruktioner om hur du återställer ditt lösenord.</span>
                   <p data-bs-toggle="modal" data-bs-target="#loginModal" class="cursor-pointer"><u>Tillbaka till inloggning</u></p>
                </div>
            </div>
        </div>

        <!-- SUCCESSFUL REGISTRATION MODAL -->

        <!-- LOGIN FORM MODAL -->
        <div class="modal fade bd-example-modal-lg" id="loginModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content register-form">
                    <login-member-component></login-member-component>
                </div>
            </div>
        </div>
        <!-- END LOGIN FORM MODAL -->

        <!-- CLIENT LOGIN FORM MODAL -->
        <div class="modal fade" id="clientLoginModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content register-form" style="border-radius: 25px;">
                    <login-partner-component></login-partner-component>
                </div>
            </div>
        </div>
        <!-- END LOGIN FORM MODAL -->

        <!-- FORGOT PASSWORD MODAL -->
        <div class="modal fade" id="forgotPasswordModal" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content forgot-password">
                <form @submit.prevent="resetPassword">
                    <span style="font-size: 32px; display: block; margin-bottom: 10px;">Glömt lösenord!</span>
                    <input type="email" v-model="resetEmail" class="form-control" placeholder="E-postadress">
                    <div v-if="!emailExist" class="invalid-feedback text-left d-block">
                        <span v-if="!emailExist">Den här e-postadressen finns inte i vårt system.</span>
                    </div>

                    <button type="submit" class="btn btn-danger my-3">Återställ lösenord</button>
                    <p data-bs-toggle="modal" data-bs-target="#loginModal" class="cursor-pointer"><u>Tillbaka till inloggning</u></p>
                </form>
                </div>
            </div>
        </div>
        <!-- FORGOT PASSWORD MODAL -->

        <!-- MOBILE DROPDOWN MENU FOR CITIES -->
        <div class="sort-by-container cities-dropdown close fixed-bottom">

            <ul class="list list-unstyled mb-0">
                <li class="list-title"><span @click="showHideCities"><icon name="close-bold"  class="float-left"></icon></span> Välj städer</li>
                <input type="text" placeholder="Sök stad..." class="form-control search-input" v-model="filterCities">
            </ul>
            <ul class="list list-unstyled items">
                <li v-for="city in filteredCities" :key="city.id" @click="selectCity(city)"  :class="{ 'text-bold': selectedCity && selectedCity.id == city.id }" >
                     {{ city.name }}
                </li>
            </ul>
        </div><!-- END MOBILE DROPDOWN MENU -->
    </div>
</template>


<script>
    import AuthService from "../services/auth.service";
    import { router } from '@inertiajs/vue3';

    export default {
        data() {
            return {
                categoriesExpanded: false,
                subcategoriesExpanded: null,
                selectedCity: this.city ? this.city : null,
                submittedResetPass: false,
                resetEmail: "",
                emailExist: true,
                mobileMenuDisplayed: false,
                searchFocusEventAvailable: false,
                lastCategory: null,
                query: '',
                langs: ['se', 'en'],
                isNative: window.isNative,
                isIOSDevice: !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform),
                filterCities: null
            };
        },
        mounted () {
            $('.dropdown-menu a.dropdown-toggle').on('click', function(e) {
            if (!$(this).next().hasClass('show')) {
            $(this).parents('.dropdown-menu').first().find('.show').removeClass('show');
            }
            var $subMenu = $(this).next('.dropdown-menu');
            $subMenu.toggleClass('show');


            $(this).parents('li.nav-item.dropdown.show').on('hidden.bs.dropdown', function(e) {
            $('.dropdown-submenu .show').removeClass('show');
            });

            return false;
            });
        },
        methods: {
            linkBack () {
                if (this.$parent.navigated <= 0) {
                    return false;
                }

                this.$parent.navigated = this.$parent.navigated -1;
                window.history.go(-1);
            },
            removeDownloadAppBanner(){
                $("body").removeClass("with-mobile-banner");
                localStorage.setItem('with-mobile-banner', 0);
            },
            displaySubcategories(id){
                $('#category-' + id).removeClass('d-none');
            },
            checkMenuItem() {
                this.categories.forEach((element) => {
                    if ($("#category-link-" + element.id).hasClass("collapsed")) {
                        $("#open-" + element.id).addClass("d-block");
                        $("#close-" + element.id).removeClass("d-none");
                    } else {
                        $("#close-" + element.id).addClass("d-block");
                    }
                });
            },
            openCloseMenuItem(id) {
                if (id == this.lastCategory) {
                    $("#open-" + id).toggleClass("d-none");
                    $("#close-" + id).toggleClass("d-none");
                    this.lastCategory = null;
                } else {
                    $("#open-" + this.lastCategory).toggleClass("d-none");
                    $("#close-" + this.lastCategory).toggleClass("d-none");
                    $("#open-" + id).toggleClass("d-none");
                    $("#close-" + id).toggleClass("d-none");
                    this.lastCategory = id;
                }
            },
            openCloseMenu() {
                this.mobileMenuDisplayed = !this.mobileMenuDisplayed;

                if (!this.mobileMenuDisplayed) {
                    this.scrollToTop();
                }

                $(".mobile-menu").toggleClass("close");
                $(".trigger-menu").toggleClass("d-none");
            },
            openCloseMobileSearch(){
                $(".mobile-search").toggleClass("close");
                if(!$(".mobile-search").hasClass('close')){
                    $(".mobile-search input").focus();
                }else{
                    $(".mobile-search input").focusout();
                }

                if(!$(".mobile-menu").hasClass('close')){
                    this.mobileMenuDisplayed = !this.mobileMenuDisplayed;
                    $(".mobile-menu").toggleClass("close");
                    $(".trigger-menu").toggleClass("d-none");
                    // $("body").toggleClass("overflow-hidden");
                }

                if (!this.searchFocusEventAvailable) {
                    $('.mobile-search input').on('focus', this.onSearchInputFocus);
                }
            },
            checkIfClient() {
                if (this.currentUser?.type === 'client') {
                    router.visit('/kund');
                } else {
                    $("#clientLoginModal").modal("toggle");
                }
            },
            search(){
                router.visit(`/sok?term=${encodeURIComponent(this.query)}`);
                this.hideKeyboard($(".mobile-search input"));
                $(".mobile-search input").focusout();
            },
            hideKeyboard(element) {
                element.attr('readonly', 'readonly'); // Force keyboard to hide on input field.
                element.attr('disabled', 'true'); // Force keyboard to hide on textarea field.
                setTimeout(function() {
                    element.blur();  //actually close the keyboard
                    // Remove readonly attribute after keyboard is hidden.
                    element.removeAttr('readonly');
                    element.removeAttr('disabled');
                }, 100);
            },
            onSearchInputFocus() {
                this.searchFocusEventAvailable = true;
                setTimeout(() => {
                    if($(".mobile-search").hasClass('close')){
                        $(".mobile-search").removeClass('close');
                        // cursor was at first line even when there was text inside fix
                        const searchInput = $(".mobile-search input");
                        var tmpStr = searchInput.val();
                        searchInput.val('');
                        searchInput.val(tmpStr);
                    }
                }, 100)
            },
            scrollToTop() {
                window.scrollTo(0, 0);
            },
            showHideCities(){
                this.filterCities = null;
                $('.cities-dropdown').toggleClass('close');
                $('.mobile-menu').addClass('close');
            },
            selectCity(city){
                this.selectedCity = city;
                this.$store.dispatch('setCity', city);
                this.showHideCities();
                Event.$emit('city-changed', this.selectedCity);
            },
            resetPassword(){
                this.submittedResetPass = true;

                axios.get('/api/user/checkemail/'+ this.resetEmail).then(response => {
                   if(response.data.data.exist == true){
                       this.sendEmail();
                   }else{
                       this.emailExist = false;
                   }
                });
            },
            sendEmail(){
                axios.post('/api/password/email', {email: this.resetEmail, type: 'api'}).then(response => {
                    $("#forgotPasswordModal").modal("hide");
                    $("#emailSent").modal("show");
               });
            },
            logout(){
                AuthService.logout();
            },
            closeSuccessRegistrationModal() {
                $('#successRegistrationModal').modal('hide');

                setTimeout(() => {
                    router.visit(`/kampanjer`);
                }, 300)
            },
        },
        computed:{
            currentUser() {
                return this.$page.props.currentUser;
            },
            categories() {
                return this.$page.props.categories;
            },
            cities() {
                return this.$page.props.cities;
            },
            city() {
                return this.$store.state.city;
            },

            filteredCities(){
            if (!this.filterCities) return this.cities
            let searchText = this.filterCities.toLowerCase()
            return this.cities.filter(p => {
                return p.name.toLowerCase().includes(searchText)
                })
            }
        }
    };
</script>
